import * as Tooltip from "@radix-ui/react-tooltip";
import { ReactNode } from "react";

interface CustomTooltipProps {
  children: ReactNode;
  content: string;
}

const CustomTooltip = ({ children, content }: CustomTooltipProps) => (
  <Tooltip.Provider delayDuration={0}>
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
      <div className="cursor-pointer">
          {children}
        </div>
        </Tooltip.Trigger>
      <Tooltip.Content
      side="top"
        align="start"
        className="rounded-md bg-black text-white px-4 py-3 text-sm shadow-md z-[999] translate-x-20 max-w-[400px] max-h-[300px] overflow-y-auto overflow-x-hidden break-words whitespace-normal custom-scrollbar scrollbar-thin scrollbar-thumb-[#424242] scrollbar-track-[#1C1C1C]"
      >
        {content}
      </Tooltip.Content>
    </Tooltip.Root>
  </Tooltip.Provider>
);

export default CustomTooltip;
